import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// SERVICES
import { ThemeService } from './services/theme.service';
import { NavigationService } from "./services/navigation.service";
import { RoutePartsService } from './services/route-parts.service';
import { AppConfirmService } from './services/app-confirm/app-confirm.service';
import { AppLoaderService } from './services/app-loader/app-loader.service';
import { AuthGuard } from './../auth/guard/auth.guard';
import { UserRoleGuard } from './../auth/guard/user-role.guard';

import { SharedComponentsModule } from './components/shared-components.module';
import { SharedPipesModule } from './pipes/shared-pipes.module';
import { SharedDirectivesModule } from './directives/shared-directives.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { TokenDataService } from './services/token-data.service';
import { FileUploadDownloadService } from './services/file-upload-download.service';
import { SetujOrganIzMaticneEvidencijeService } from './services/setuj-organ-iz-maticne-evidencije.service';
import { SetujNadredjeneEntiteteZaUnosOJService } from './services/setuj-nadredjene-entitete-za-unos-oj.service';
import { AdministratorMetaregistraGuard } from 'app/auth/guard/admin-metaregistra.guard';
@NgModule({
  imports: [
    CommonModule,
    SharedComponentsModule,
    SharedDirectivesModule,
    FlexLayoutModule,
    TranslateModule
  ],
  providers: [
    ThemeService,
    NavigationService,
    RoutePartsService,
    AuthGuard,
    UserRoleGuard,
    AdministratorMetaregistraGuard,
    AppConfirmService,
    AppLoaderService,
    TokenDataService,
    FileUploadDownloadService,
    SetujOrganIzMaticneEvidencijeService,
    SetujNadredjeneEntiteteZaUnosOJService
  ],
  exports: [
    SharedComponentsModule,
    SharedPipesModule,
    SharedDirectivesModule,
    FlexLayoutModule,
    TranslateModule,
  ]
})
export class SharedModule { }
